var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39995 5.86667V5.25715C4.39995 3.23121 6.00567 1.60001 7.99995 1.60001C9.99424 1.60001 11.6 3.23121 11.6 5.25715V5.86667M4.39995 5.86667C3.73995 5.86667 3.19995 6.41524 3.19995 7.08572V13.181C3.19995 13.8514 3.73995 14.4 4.39995 14.4H11.6C12.26 14.4 12.8 13.8514 12.8 13.181V7.08572C12.8 6.41524 12.26 5.86667 11.6 5.86667M4.39995 5.86667H11.6M7.99995 10.8V9.20001",
    stroke: "current",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.d8331cf2313d5966e592bf0a459b9e18.svg";
export { ForwardRef as ReactComponent };